import { createContext } from "react";
const AttributeMasterContext = createContext({});

export default AttributeMasterContext;
